<template>
  <div>
    <ValidationProvider :name="$t(itemName)" rules="required" v-slot="{ errors }">
      <v-combobox
        v-model="editedItem"
        :items="allItem"
        :item-text="setItemText"
        :item-value="(item) => item.Number + item.Name"
        :label="$t(itemName)"
        required
        return-object
        :loading-text="$t('common_get_data')"
        :no-data-text="$t('common_no_results')"
        @change="chooseItem"
        :error-messages="errors[0]"
        :ref="refName"
        @keyup.enter="keyupEnter"
        @click="getItems()"
      >
        <template v-slot:item="data">
          <template>
            <v-list-item-content>
              <v-list-item-title>{{ data.item.Number }}</v-list-item-title>
              <v-list-item-subtitle>{{ data.item.Name }}</v-list-item-subtitle>
              <v-list-item-subtitle>{{ data.item.Remark }}</v-list-item-subtitle>
            </v-list-item-content>
          </template>
        </template>
        <template v-slot:selection="{ item }">
          {{ setSelectText(item) }}
        </template>
        <template v-slot:label>
          <span class="red--text">
            <strong>* </strong>
          </span>
          {{ $t(itemName) }}
        </template>
      </v-combobox>
    </ValidationProvider>
  </div>
</template>

<script>
import { HttpItem } from '@/js/http-Manager'
export default {
  name: 'MonthItemCombobox',
  props: {
    fatherEditedItem: {
      type: Object
    },
    itemName: {
      type: String
    },
    refName: {
      type: String
    }
  },
  components: {},
  data: () => ({
    allItem: [],
    isLoadingItem: false,

    editedItem: {
      Number: '',
      Name: ''
    },
    defaultItem: {
      Number: '',
      Name: ''
    }
  }),
  async mounted () {
    await this.getItems()
  },
  watch: {
    async fatherEditedItem (val) {
      if (val.Name === '') {
        await this.getItems()
        this.editedItem = JSON.parse(JSON.stringify(this.defaultItem))
      } else {
        this.editedItem = JSON.parse(JSON.stringify(val))
      }
    }
  },
  methods: {
    keyupEnter (event) {
      this.$refs[this.refName].isMenuActive = false
      this.$refs[this.refName].isFocused = false
      this.$emit('keyupEnter', event)
    },
    chooseItem () {
      if (typeof this.editedItem === 'string') {
        this.editedItem = JSON.parse(
          JSON.stringify({
            Number: '',
            Name: this.editedItem,
            Quantity: 0,
            Price: 0,
            WarrantyPeriod: 0
          })
        )
      }
      if (this.editedItem) {
        this.$emit('setEditedMonthItem', this.editedItem)
      } else {
        this.$emit('setEditedMonthItem', this.defaultItem)
      }
    },
    setSelectText (item) {
      return item.Name
    },
    setItemText (item) {
      return item.Number + ' - ' + item.Name
    },
    async getItems () {
      this.isLoadingItem = true
      let response = await HttpItem.GetMonthItem()
      this.allItem = response.status === 200 ? response.data.Data : []
      this.isLoadingItem = false
    }
  }
}
</script>
